import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgListView = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 2a2 2 0 0 0-2 2v5.143a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-.286 2c0-.158.128-.286.286-.286h16c.158 0 .286.128.286.286v5.143a.286.286 0 0 1-.286.286H4a.286.286 0 0 1-.286-.286zM4 12.857a2 2 0 0 0-2 2V20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.143a2 2 0 0 0-2-2zm-.286 2c0-.158.128-.286.286-.286h16c.158 0 .286.128.286.286V20a.286.286 0 0 1-.286.286H4A.286.286 0 0 1 3.714 20z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgListView;
